export default function Window()
{
  let scrollBarWidth = null;


  this.setWindowName = (w, n) =>
  {
    if (w && n != null)
    {
      w.name = n;
    }
  };


  this.setAutoWindowName = (w, p) =>
  {
    if (w)
    {
      p = (p || '') + '_' + windowNameCounter++; this.setWindowName(w, p);
    }
  };


  this.getWindowSizes = (win = window) =>
  {
    const ret =
    {
      scrollWidth: 0,
      scrollHeight: 0,
      clientWidth: 0,
      clientHeight: 0,
      innerWidth: 0,
      innerHeight: 0,
      scrollLeft: 0,
      scrollTop: 0
    };

    if (win.document && win.document.documentElement)
    {
      ret.clientWidth = this.getInnerWidth(win) || 0;
      ret.clientHeight = this.getInnerHeight(win) || 0;

      ret.scrollWidth = Math.max((win.document.documentElement.scrollWidth || 0), ret.clientWidth);
      ret.scrollHeight = Math.max((win.document.documentElement.scrollHeight || 0), ret.clientHeight);

      ret.innerWidth = win.innerWidth || win.document.documentElement.offsetWidth || 0;
      ret.innerHeight = win.innerHeight || win.document.documentElement.offsetHeight || 0;

      ret.scrollLeft = this.getScrollLeft(win);
      ret.scrollTop = this.getScrollTop(win);

      ret.altScrollLeft = this.getAltScrollLeft(win);
      ret.altScrollTop = this.getAltScrollTop(win);
    }

    return ret;
  };


  this.getInnerHeight = (win = window) =>
  {
    let innerHeight = 0;

    if (!win.document) { return 0; }

    if (BEditor.browser.isIE)
    {
      if (win.document.documentElement.clientHeight)
      {
        innerHeight = win.document.documentElement.clientHeight;
      }
      else
      {
        innerHeight = win.document.body.clientHeight;

        if (this.getScrollWidth(win) > win.document.body.clientWidth || BEditor.styleHelpers.getElementStyle(win.document.querySelector('HTML'), 'overflowX') === 'scroll')
        {
          innerHeight -= this.getScrollBarWidth();
        }
      }
    }
    else
    {
      innerHeight = (win.document.compatMode === 'CSS1Compat' && BEditor.device.isDesktop) ?
        (win.document.documentElement ? win.document.documentElement.clientHeight : 0) // FF bug
        : win.document.body.clientHeight;
    }

    return innerHeight;
  };


  this.getInnerWidth = (win = window) =>
  {
    let innerWidth = 0,
        saveFloat = null,
        isDocumentElement;

    if (!win.document) { return 0; }

    if (BEditor.browser.isIE)
    {
      if (win.document.documentElement.clientWidth)
      {
        innerWidth = win.document.documentElement.clientWidth;
      }
      else
      {
        innerWidth = win.document.body.clientWidth;

        if (this.getScrollHeight(win) > win.document.body.clientHeight || BEditor.styleHelpers.getElementStyle(win.document.querySelector('HTML'), 'overflowY') === 'scroll')
        {
          innerWidth -= this.getScrollBarWidth();
        }
      }
    }
    else
    {
      isDocumentElement = !!(win.document.documentElement);

      if (BEditor.device.isMobile)
      {
        if (isDocumentElement)
        {
          saveFloat = win.document.documentElement.style.cssFloat;
          win.document.documentElement.style.cssFloat = 'left';
        }
        else
        {
          saveFloat = win.document.body.style.cssFloat;
          win.document.body.style.cssFloat = 'left';
        }
      }

      innerWidth = (document.compatMode === 'CSS1Compat' && BEditor.device.isDesktop) ?
        (isDocumentElement ? win.document.documentElement.clientWidth : 0) // FF bug
        : win.document.body.clientWidth;

      if (saveFloat !== null)
      {
        if (isDocumentElement)
        {
          win.document.documentElement.style.cssFloat = saveFloat;
        }
        else
        {
          win.document.body.style.cssFloat = saveFloat;
        }
      }
    }

    return innerWidth;
  };


  this.getScrollBarWidth = (w = window) =>
  {
    let d,
        objDiv,
        objDivOffsetWidth,
        objDivClientWidth;

    if (!scrollBarWidth)
    {
      d = w.document;
      objDiv = d.createElement('DIV');

      if (objDiv)
      {
        objDiv.style.position = 'absolute';
        objDiv.style.left = objDiv.style.top = '-1000px';
        objDiv.style.width = objDiv.style.height = '100px';
        objDiv.style.overflow = 'scroll';
        objDiv.style.visibility = 'hidden';

        if (d.body)
        {
          d.body.appendChild(objDiv);

          objDivOffsetWidth = objDiv.offsetWidth;
          objDivClientWidth = objDiv.clientWidth;

          if (objDiv && objDivOffsetWidth && objDivClientWidth)
          {
            scrollBarWidth = objDivOffsetWidth - objDivClientWidth;
          }
        }
      }
    }

    if (objDiv)
    {
      objDiv.parentNode.removeChild(objDiv);
    }

    return scrollBarWidth;
  };


  this.getScrollHeight = (win = window) =>
  {
    return win.document.body.scrollHeight;
  };


  this.getScrollWidth = (win = window) =>
  {
    return win.document.body.scrollWidth;
  };


  this.getAltScrollContainer = (w = window) =>
  {
    return BEditor.domHelpers.$('idComponentFrame', w);
  };


  this.getScroll = (win = window) =>
  {
    return { left: this.getScrollLeft(win), top: this.getScrollTop(win) }
  };


  this.getScrollLeft = (w = window) =>
  {
    if (typeof(w.pageXOffset) === 'number')
    {
      return w.pageXOffset;
    }

    const docElement = w.document.documentElement;

    if (docElement && docElement.scrollLeft)
    {
      return docElement.scrollLeft;
    }

    const docBody = w.document.body;

    if (docBody && docBody.scrollLeft)
    {
      return docBody.scrollLeft;
    }

    return 0;
  };


  this.getScrollTop = (w = window) =>
  {
    const offset = w.pageYOffset;

    if (typeof(offset) === 'number')
    {
      return offset;
    }

    const docElement = w.document.documentElement;

    if (docElement && docElement.scrollTop)
    {
      return docElement.scrollTop;
    }

    const docBody = w.document.body;

    if (docBody && docBody.scrollTop)
    {
      return docBody.scrollTop;
    }

    return 0;
  };


  this.getAltScrollLeft = (w = window) =>
  {
    const componentFrame = this.getAltScrollContainer(w);

    return (componentFrame ? componentFrame.scrollLeft : 0);
  };


  this.getAltScrollTop = (w = window) =>
  {
    const componentFrame = this.getAltScrollContainer(w);

    return (componentFrame ? componentFrame.scrollTop : 0);
  };


  this.getFullScroll = (element, win = window, args = {}) =>
  {
    let i,
        limiters = args.limiters,
        isLimiters = !!limiters,
        scrollLeft = (args.isOnlyElements ? 0 : this.getScrollLeft(win)),
        scrollTop = (args.isOnlyElements ? 0 : this.getScrollTop(win)),
        parentElement = element.parentElement;

    if (isLimiters && limiters.length > 0)
    {
      for (i = 0; i < limiters.length; i++)
      {
        scrollLeft += limiters[i].scrollLeft;
        scrollTop += limiters[i].scrollTop;
      }
    }
    else
    {
      while (parentElement && parentElement.nodeName !== 'BODY')
      {
        if (isLimiters)
        {
          if ((parentElement.getAttribute('data-scrollable') != null || (parentElement.getAttribute('class') != null && parentElement.getAttribute('class').indexOf('scroll-container') !== -1)))
          {
            limiters.push(parentElement);
            scrollLeft += parentElement.scrollLeft;
            scrollTop += parentElement.scrollTop;
          }
        }
        else
        {
          scrollLeft += parentElement.scrollLeft;
          scrollTop += parentElement.scrollTop;
        }

        parentElement = parentElement.parentElement;
      }
    }

    return { left: scrollLeft, top: scrollTop };
  };
}
